import React from "react";
import { FaPalette, FaBolt, FaShieldHalved, FaMagnifyingGlassChart, FaMobileScreen, FaHeadset } from "react-icons/fa6";
import { Container } from "../home/ui";

const reasons = [
  { icon: FaPalette, title: "Unique & Modern Design", text: "Stand out with a design that matches your brand.", tone: "bg-[#E3EEFF] text-[#1E6BFF]" },
  { icon: FaBolt, title: "High Performance", text: "Lightning-fast speed and optimized code.", tone: "bg-[#EEE8FF] text-[#6D28D9]" },
  { icon: FaShieldHalved, title: "Advanced Security", text: "Keep your data and users safe, always.", tone: "bg-[#E2F7EA] text-[#16A34A]" },
  { icon: FaMagnifyingGlassChart, title: "SEO Friendly", text: "Get better visibility and organic traffic.", tone: "bg-[#F3E6FF] text-[#9333EA]" },
  { icon: FaMobileScreen, title: "Responsive Design", text: "Perfect experience on all devices.", tone: "bg-[#FFEBDD] text-[#F97316]" },
  { icon: FaHeadset, title: "Dedicated Support", text: "We're with you, every step of the way.", tone: "bg-[#E3EEFF] text-[#1E6BFF]" },
];

// "Your Vision / Our Code" hand-drawn note with a curved arrow.
const VisionNote = () => (
  <div className="relative mt-[40px] hidden h-[110px] w-[200px] lg:block" aria-hidden="true">
    <svg viewBox="0 0 60 80" fill="none" className="absolute left-[10px] top-0 h-[70px] w-[50px]">
      <path d="M8 4 C 2 30, 10 55, 40 70" stroke="#6D28D9" strokeWidth="2" strokeLinecap="round" />
      <path d="M30 72 L41 71 L36 61" stroke="#6D28D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <p className="absolute left-[60px] top-[18px] -rotate-[10deg] font-hand text-[22px] leading-[1.2] text-[#4C1D95]">
      Your Vision
      <br />
      <span className="ml-[12px]">Our Code</span>
    </p>
  </div>
);

const WhyChooseCustom = () => (
  <section className="bg-white py-[40px] lg:py-[56px]">
    <Container className="max-w-[1320px]">
      <div className="grid items-center gap-[32px] rounded-[20px] border-[1px] border-solid border-[#EEF1FA] bg-gradient-to-br from-[#F5F7FE] via-[#F7F8FF] to-[#F6F5FE] p-[24px] sm:p-[32px] lg:grid-cols-[minmax(0,0.78fr)_minmax(0,1.22fr)] lg:gap-[36px] lg:px-[40px] lg:py-[32px]">
        <div className="lg:self-start lg:pt-[12px]">
          <p className="flex items-center gap-[6px] text-[11.5px] font-semibold uppercase tracking-[0.18em] text-[#7C3AED]">
            Why choose us <span className="h-[4px] w-[4px] rounded-full bg-[#7C3AED]" />
          </p>
          <h2 className="mt-[16px] text-[30px] font-bold leading-[1.22] tracking-tight text-[#0B1B4D] sm:text-[34px] xl:text-[clamp(30px,2.2vw,38px)]">
            <span className="xl:whitespace-nowrap">Why Choose Our Custom</span>
            <br />
            <span className="text-gradient xl:whitespace-nowrap">Website Development?</span>
          </h2>
          <p className="mt-[16px] max-w-[420px] text-[15px] leading-[1.6] text-slate-600">
            We don&apos;t just build websites, we build digital experiences. Our custom solutions are designed to fit your
            business goals, user needs and future growth.
          </p>
          <VisionNote />
        </div>

        <div className="grid gap-[16px] sm:grid-cols-2 xl:grid-cols-3">
          {reasons.map((r) => (
            <div
              key={r.title}
              className="rounded-[14px] bg-white px-[22px] pb-[22px] pt-[18px] shadow-[0_10px_30px_-18px_rgba(40,60,140,0.28)] transition hover:-translate-y-1"
            >
              <span
                className={`inline-flex h-[56px] w-[56px] items-center justify-center rounded-full text-[24px] shadow-[inset_0_-6px_12px_rgba(255,255,255,0.7),0_8px_18px_-10px_rgba(40,60,140,0.35)] ${r.tone}`}
              >
                <r.icon />
              </span>
              <h3 className="mt-[14px] text-[15px] font-semibold leading-[1.35] text-[#0B1B4D] xl:whitespace-nowrap">{r.title}</h3>
              <p className="mt-[8px] max-w-[200px] text-[13.5px] leading-[1.6] text-slate-500">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default WhyChooseCustom;
